import React, { Component } from 'react'
import TextField from '../shared/ppbn-textfield';


const styles = {
    textField : {
        margin: 20,
        width: '300px'
    }
};

class SearchForCustomer extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e) => {
        this.props.valueReturned(e.target.value);
    }

      
    render() {
        return (
            <div className='customer-search-section'>
                <TextField 
                    autoFocus={true} 
                    className='customer-search-field' 
                    placeholder="Enter Customer Name"
                    onChange={(e) => this.handleChange(e)} 
                    style={styles.textField}/>
            </div>
        )
    }

}

export default SearchForCustomer;